import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import axios from 'axios'

const DetectRTC = require("detectrtc");

localStorage.setItem('browser', DetectRTC.browser.name.toLowerCase())
localStorage.setItem('os', DetectRTC.osName.toLowerCase())
localStorage.setItem('mobile',DetectRTC.isMobileDevice)

// localStorage.setItem('browser', 'chrome')
// localStorage.setItem('os', 'ios')
// localStorage.setItem('mobile', true)


axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  console.log(error.response.status)
  if (error.response.status === 401) {
    store.state.user = null
    sessionStorage.removeItem('user')

    store.state.token = null
    sessionStorage.removeItem('token')

    delete axios.defaults.headers.common['Authorization']
    router.replace('/login')
  }
  return Promise.reject(error)
})




//console.log(firebase.analytics())



Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
